import { CSSProperties } from "react";

export const StyleProps1: CSSProperties = {
    color: "black",
};

export const StyleProps2 : CSSProperties ={
    height: "88px",
    backgroundColor: "#d9d9f3",
    border: "1px solid #ff5100"
}
